import React from 'react';
import PropTypes from 'prop-types';
import { padTwo } from '@widergy/web-utils/lib/normalize';

import { dotLineWidth } from 'constants/sizes';

function CustomActiveDot({ cx, cy, color, value, index, activeValue, payload = {}, onClick, year }) {
  const activeDotStyle = {
    stroke: color,
    strokeOpacity: '.4',
    strokeWidth: 10
  };
  return value ? (
    <svg>
      <circle
        cx={cx}
        cy={cy}
        r={dotLineWidth}
        onClick={() => onClick(payload, year)}
        style={
          activeValue && padTwo(index + 1) === activeValue
            ? {
                fill: color,
                ...activeDotStyle
              }
            : { fill: color }
        }
      />
    </svg>
  ) : null;
}

CustomActiveDot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  value: PropTypes.number,
  index: PropTypes.number,
  activeValue: PropTypes.string,
  color: PropTypes.string.isRequired,
  payload: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  onClick: PropTypes.func.isRequired,
  year: PropTypes.string
};

export default CustomActiveDot;
